import AbstractNomenclature, { DataColumn } from "./common/AbstractNomenclature";
import { FormikProvider } from "formik";
import CustomInputText from "../../components/forms/CustomInputText";
import * as Yup from "yup";
import { groupsApi } from "../../services/nomenclatures/groupsApi";
import { AcademicYearResponse, GroupResponse, SpecialityResponse } from "../../models/dtos";
import CustomDropdown from "../../components/forms/CustomDropdown";
import { specialitiesApi } from "../../services/nomenclatures/specialitiesApi";
import { academicYearsApi } from "../../services/nomenclatures/academicYearsApi";
import { ApiResponse } from "../../services/base/apiResponse";

export const createEditDialog = (
  specialities?: ApiResponse<SpecialityResponse[]>,
  academicYears?: ApiResponse<AcademicYearResponse[]>,
) => ({
  renderForm: (formik: any) => (
    <FormikProvider value={formik}>
      {formik.values.groupId && <CustomInputText label="ID" id="groupId" disabled />}
      <CustomInputText label="Име" id="name" />
      <CustomDropdown
        id="specialityId"
        label="Специалност"
        options={specialities?.data ?? []}
        optionLabel="name"
        optionValue="specialityId"
        placeholder="Изберете опция"
      />
      <CustomDropdown
        id="academicYearId"
        label="Академична година"
        options={academicYears?.data ?? []}
        optionLabel="name"
        optionValue="academicYearId"
        placeholder="Изберете опция"
      />
      <CustomInputText label="Курс" id="courseYear" />
    </FormikProvider>
  ),
  validationSchema: Yup.object().shape({
    name: Yup.string().required("Трябва да въведете име"),
    specialityId: Yup.number().required("Трябва да изберете специалност"),
    academicYearId: Yup.number().required("Трябва да изберете академична година"),
  }),
});

const Groups = () => {
  const api = {
    useGetListQuery: groupsApi.useGetGroupsQuery,
    useUpdateItemMutation: groupsApi.useUpdateGroupMutation,
    useDeleteItemMutation: groupsApi.useDeleteGroupMutation,
  };

  const { data: specialities } = specialitiesApi.useGetSpecialitiesQuery();
  const { data: academicYears } = academicYearsApi.useGetAcademicYearsQuery();

  const columns: DataColumn<GroupResponse>[] = [
    { field: "groupId", header: "ID", sortable: true, filter: true },
    { field: "name", header: "Име", sortable: true, filter: true },
    { field: "specialityName", header: "Специалност", sortable: true, filter: true },
    { field: "academicYearName", header: "Година", sortable: true, filter: true },
    { field: "courseYear", header: "Курс", sortable: true, filter: true },
  ];

  const editDialog = createEditDialog(specialities, academicYears);

  return (
    <AbstractNomenclature
      api={api}
      columns={columns}
      editDialog={editDialog}
      exportFilename="groups"
      title="Groups"
      idField="groupId"
    />
  );
};

export default Groups;
